import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@ui/Box';
import Button from '@ui/Button';
import Textarea from '@ui/Textarea';

interface Props {
  comment: string;
  setComment: (comment: string) => void;
  submitVote: () => void;
}

const CommentBox = ({ comment, setComment, submitVote }: Props) => {
  const { t } = useTranslation();
  return (
    <Box className="PageThumbs-comment_box" kind="card">
      <div className="PageThumbs-comment-body">
        <label>
          {t('pageThumbs.placeHolder')}
          <Textarea className="PageThumbs-comment_input" onChange={e => setComment(e.target.value)} value={comment} />
        </label>
      </div>
      <footer className="PageThumbs-comment-footer">
        <Button className="PageThumbs-comment_submit" onClick={submitVote} size="sm">
          {t('pageThumbs.submit')}
        </Button>
      </footer>
    </Box>
  );
};

export default CommentBox;
